import React from 'react'
import { ImageLoader } from '@usap/uicomponents'
import { Container, Label, ImageContainer, ImageBox } from "./style/ReturnReasonsWMO.css"

const ReturnReasonsWMO = ({ orderDetails }) => {
  const { item } = orderDetails
  const { reasons, uploaded } = item

  if (reasons === null) {
    return null
  }

  return (
    <Container>
      <Label>Return Details:</Label>
      <ul>
        {reasons.map((data) => (
          data?.answer && <li key={data.id}>
            { data.answer }
          </li>
        ))}
      </ul>
      <ImageContainer>
        {uploaded.images.map(data => (
          <ImageBox key={data.id}>
            <ImageLoader
              src={data.url}
              height="90px"
              width="90px"
              fit="cover"
              cloudinaryParams="w_100,h_80"
              style={{ borderRadius: "4px" }}
            />
          </ImageBox>
        ))}
      </ImageContainer>
    </Container>
  )
}

export default ReturnReasonsWMO